export const addToCartCrossSellingBottomSheet = {
    name: "AddToCartCrossSellingBottomSheet",
    variants: [
        ["Control", 1],
        ["Test", 1], // Treatment
    ],
    controlVariant: "Control",
    apply: ({ assignVariant, clearVariant, isParticipatingInOtherTests }) => {
        if (Skubacz.configuration.environment === "systemtest") {
            return;
        }
        const validCountry = Skubacz.configuration.country === "PL";
        const validTheme = Skubacz.configuration.theme_name !== "active_menu";
        const isInOtherTest = isParticipatingInOtherTests();
        if (validCountry && validTheme && !isInOtherTest) {
            assignVariant();
        }
        else {
            clearVariant();
        }
    },
};
